import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import Sidebar from "../../layout/Sidebar";
import Navbar from "../../layout/Navbar";
import ReactToPrint from "react-to-print";
import { getAllAccount } from "../../../actions/accountsAction";
import { resetAllChartofaccounts } from "../../../actions/chartofaccountsAction";
import { getJournalSearchResult } from "../../../actions/journalAction";
import { getAllLocation, getAllOutlet } from "../../../actions/warehouseAction";
import {
  getallaccountstatus,
  accountstatus,
} from "../../../actions/accounting/AccountsByDate";
import dateFormat from "dateformat";

import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  DatePicker,
  Space,
  Select,
  Divider,
  Skeleton,
  Button,
  Spin,
  Collapse,
} from "antd";
const { Panel } = Collapse;
const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Option } = Select;

const AccountsStatus = ({
  getJournalSearchResult,
  accountstatus,
  resetAllChartofaccounts,
  getAllAccount,
  getallaccountstatus,
  getAllLocation,
  locationlist,
  brandlist,
  getAllOutlet,
}) => {
  const componentRef = useRef();
  const [accounts, setAccounts] = useState([]);
  const [chartofaccounts, setChartOfAccounts] = useState([]);
  const [data, setdata] = useState([]);
  const [loading, setloading] = useState(true);
  const [reload, setreload] = useState(true);
  const [dataFetched, setDateFetched] = useState(false);
  var currentdate = new Date();
  var today =
    currentdate.getFullYear() +
    "-" +
    (currentdate.getMonth() + 1) +
    "-" +
    currentdate.getDate() +
    "T23:59:59";
  var accountsstart = "";
  if (currentdate.getMonth() + 1 > 6) {
    accountsstart =
      currentdate.getFullYear() + 1 + "-7-01T00:00:01";
  } else {
    accountsstart =
      currentdate.getFullYear() +
      "-7-01T00:00:01";
  }
  // accountsstart = "2022-07-01T00:00:01";

  const openingDate = useRef(accountsstart);
  const start = useRef("");
  const end = useRef(today);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const totalBranch = useRef(0);
  const totalcash = useRef(0);

  const totaldebit = useRef(0);
  const totalcredit = useRef(0);
  const endingBalance = useRef(0);

  const openingcredit = useRef(0);
  const openingdebit = useRef(0);
  const openingbalance = useRef(0);
  useEffect(() => {
    getAllOutlet()
    getAllAccount().then((result) => {
      let account = [];
      for (let i = 0; i < result.length; i++) {
        account.push(result[i]);
      }
      resetAllChartofaccounts().then((chartofaccount) => {
        setChartOfAccounts(chartofaccount.data);
        chartofaccount.data.filter((item) => {
          if (item.name == "Cash") {
            totalcash.current = item.amount;
            // alert("Total Cash: " + totalcash.current);
          }
        })
        accountstatus().then((res) => {
          setAccounts(account);
          setdata(res);
          setloading(false);
        });
      });
    });
  }, []);



  const SwitchablePicker = () => {
    return (
      <Row>
        {/* <Col flex="auto">
          <h3>Date:</h3>
          <RangePicker
            style={{ width: "100%" }}
            onChange={(value) => {
              if (value) {
                // openingDate.current = value.format("YYYY") + "-07-01T00:00:00";
                openingDate.current =
                  value[0].format("YYYY-MM-DD") + "T00:00:00";
                end.current = value[1].format("YYYY-MM-DD") + "T23:59:59";
                // setStartTime(value.format("YYYY-MM-DD") + "T00:00:00");
                // setEndTime(value.format("YYYY-MM-DD") + "T23:59:59");
                setreload(!reload);
              }
            }}
          />
        </Col> */}

        <Col flex="auto">
          {/* <h3>.</h3> */}

          <ReactToPrint
            trigger={() => (
              <Button
                type="primary"
              // style={{ width: "100%" }}
              >
                Print Report
              </Button>
            )}
            content={() => componentRef.current}
          />
        </Col>
      </Row>
    );
  };

  const Rendercontent = () => {
    return (
      <>
        <Row>
          <Col
            span={24}
            style={{ padding: "1rem", border: "1px solid whitesmoke" }}
          >
            {SwitchablePicker()}
            <Divider />
            {openingDate.current != "" && end.current != "" ? (
              <Spin spinning={loading}>
                <div ref={componentRef}>
                  <table className="account_table">
                      <tr
                        style={{
                          textAlign: "center",
                          backgroundColor: "#f0f0f0",
                          minHeight: "50px",
                        }}
                      >
                        <td colSpan={3}>
                          <b>
                            <h2>{brandlist[0]?.name}</h2>
                            <h3>Account status</h3>
                            <h3>as of {dateFormat(currentdate, "mmmm dS, yyyy, h:MM:ss TT")}</h3>
                          </b>
                        </td>
                      </tr>
                  </table>
                  <Divider />
                  <Row>
                    <Col span={11}>


                      <table className="account_table">
                        <tr style={{ background: "lightgray" }}>
                          <th
                            colSpan={4}
                            style={{ padding: "10px", textAlign: "center" }}
                          >
                            CASH
                          </th>
                        </tr>
                        <tr style={{ background: "#f0f0f0" }}>
                          <th
                            style={{
                              textAlign: "left",
                              padding: "10px",
                              width: "40%",
                            }}
                          >
                            Account Name
                          </th>
                          {/* <th>Location</th> */}
                          {/* <th>Account Number</th> */}
                          <th style={{ textAlign: "right", padding: "10px" }}>
                            Amount
                          </th>
                        </tr>
                        {RenderMethod("Cash")}
                      </table>
                      <br></br>
                      <table className="account_table">
                        <tr style={{ background: "lightgray" }}>
                          <th
                            colSpan={4}
                            style={{ padding: "10px", textAlign: "center" }}
                          >
                            Inter Office Account
                          </th>
                        </tr>
                        <tr style={{ background: "#f0f0f0" }}>
                          <th
                            style={{
                              textAlign: "left",
                              padding: "10px",
                              width: "40%",
                            }}
                          >
                            Account Name
                          </th>
                          {/* <th>Location</th> */}
                          {/* <th>Account Number</th> */}
                          <th style={{ textAlign: "right", padding: "10px" }}>
                            Amount
                          </th>
                        </tr>
                        {RenderInterOfficeAccount()}
                      </table>
                      <br></br>
                      <table className="account_table">
                        <tr style={{ background: "lightgray" }}>
                          <th
                            colSpan={4}
                            style={{ padding: "10px", textAlign: "center" }}
                          >
                            Untracked
                          </th>
                        </tr>
                        <tr style={{ background: "#f0f0f0" }}>
                          <th
                            style={{
                              textAlign: "left",
                              padding: "10px",
                              width: "40%",
                            }}
                          >
                            {/* Account Name */}
                          </th>
                          {/* <th>Location</th> */}
                          {/* <th>Account Number</th> */}
                          <th style={{ textAlign: "right", padding: "10px" }}>
                            Amount
                          </th>
                        </tr>

                        {RenderMethod("Untracked")}
                      </table>
                    </Col>
                    <Col span={12} offset={1}>
                      <table className="account_table">
                        <tr style={{ background: "lightgray" }}>
                          <th
                            colSpan={4}
                            style={{ padding: "10px", textAlign: "center" }}
                          >
                            BANK
                          </th>
                        </tr>
                        <tr style={{ background: "#f0f0f0" }}>
                          <th
                            style={{
                              textAlign: "left",
                              padding: "10px",
                              width: "40%",
                            }}
                          >
                            Account Name
                          </th>
                          {/* <th>Location</th> */}
                          {/* <th>Account Number</th> */}
                          <th style={{ textAlign: "right", padding: "10px" }}>
                            Amount
                          </th>
                        </tr>
                        {RenderMethod("Bank")}
                      </table>
                      <br></br>
                      <table className="account_table">
                        <tr style={{ background: "lightgray" }}>
                          <th
                            colSpan={4}
                            style={{ padding: "10px", textAlign: "center" }}
                          >
                            Mobile Banking
                          </th>
                        </tr>
                        <tr style={{ background: "#f0f0f0" }}>
                          <th
                            style={{
                              textAlign: "left",
                              padding: "10px",
                              width: "40%",
                            }}
                          >
                            Account Name
                          </th>
                          {/* <th>Location</th> */}
                          {/* <th>Account Number</th> */}
                          <th style={{ textAlign: "right", padding: "10px" }}>
                            Amount
                          </th>
                        </tr>
                        {RenderMethod("Mobile banking")}
                      </table>
                    </Col>
                  </Row>



                  <br></br>




                  <Row style={{ minHeight: "60px", marginTop: "40px" }}>
                    <Col span={12} style={{ textAlign: "left" }}></Col>
                    <Col span={12} style={{ textAlign: "center" }}></Col>
                  </Row>
                  <Row>
                    <Col span={12} style={{ textAlign: "left" }}>
                      <h3
                        style={{
                          borderTop: "2px solid black",
                          display: "inline-block",
                        }}
                      >
                        ACCOUNT SIGNATURE
                      </h3>
                    </Col>
                    <Col span={12} style={{ textAlign: "right" }}>
                      <h3
                        style={{
                          borderTop: "2px solid black",
                          display: "inline-block",
                        }}
                      >
                        AUTHORIZER SIGNATURE
                      </h3>
                    </Col>
                  </Row>
                </div>
              </Spin>
            ) : (
              "Please select a date"
            )}
          </Col>
        </Row>
      </>
    );
  };

  const RenderInterOfficeAccount = () => {
    return chartofaccounts.map((item) => {
      if (!item.name || !item.name.includes("Inter Office Account")) return null;
      return (
        <>
          <tr>
            <td style={{ textAlign: "left" }}>{item.name}</td>
            {/* <td></td> */}
            <td style={{ textAlign: "right" }}>
              {parseFloat(item.amount).toFixed(2)}
              {/* {parseFloat(accountTotal).toFixed(2)} */}
            </td>
          </tr>
        </>
      );
    });
  }

  const RenderMethod = (type) => {
    let typetotal = 0;
    if (type == "Cash") {
      // count all branch total cash
      totalBranch.current = 0;
      for (let i = 0; i < locationlist.length; i++) {
        // console.log(locationlist[i])
        if (locationlist[i].is_outlet && locationlist[i].name != "Anzara HQ" && locationlist[i].name != "Azran HQ" && locationlist[i].name != "Elor HQ") {
          totalBranch.current += parseFloat(locationlist[i].cash);
        }
      }

      return (
        <>
          {accounts.map((account) => {
            // console.log(data)
            if (type == account.type) {
              let accountTotal = 0;
              data.map((item) => {
                if (item.id == account.id) {
                  // typetotal += parseFloat(status.amount);
                  accountTotal += parseFloat(item.amount);
                }

              });
              return (
                <>
                  <tr>
                    <td style={{ textAlign: "left" }}>{account.name}</td>
                    {/* <td>{account.account_no}</td> */}
                    <td style={{ textAlign: "right" }}>
                      {parseFloat(totalcash.current - totalBranch.current).toFixed(2)}
                      {/* {parseFloat(accountTotal).toFixed(2)} */}
                    </td>
                  </tr>
                </>
              );
            }
          })}
          {locationlist?.map((location) => {
            if (location.cash > 0 && location.is_outlet && location.name != "Anzara HQ" && location.name != "Azran HQ" && location.name != "Elor HQ") {
              return (
                <>
                  <tr>
                    <td style={{ textAlign: "left" }}>
                      Location - {location.name}
                    </td>
                    {/* <td>All</td> */}
                    {/* <td></td> */}
                    <td style={{ textAlign: "right" }}>
                      {parseFloat(location.cash).toFixed(2)}{" "}
                    </td>
                  </tr>
                </>
              );
            }
          })}
          <tr>
            <td style={{ textAlign: "left" }} colSpan={1}>
              <b>Total</b>
            </td>

            <td style={{ textAlign: "right" }}>
              <b>{parseFloat(totalcash.current).toFixed(2)}</b>
            </td>
          </tr>
        </>
      );
    } else if (type == "Bank") {
      return (
        <>
          {accounts.map((account) => {
            if (type == account.type) {
              let accountTotal = 0;
              data.map((item) => {
                if (item.id == account.id) {
                  typetotal += parseFloat(item.amount);
                  accountTotal += parseFloat(item.amount);
                  // console.log(status);
                }
              });
              return (
                <>
                  <tr>
                    <td style={{ textAlign: "left" }}>{account.name}</td>
                    {/* <td>All</td> */}
                    {/* <td>{account.account_no}</td> */}
                    <td style={{ textAlign: "right" }}>
                      {parseFloat(accountTotal).toFixed(2)}
                    </td>
                  </tr>
                </>
              );
            }
          })}

          <tr>
            <td style={{ textAlign: "left" }} colSpan={1}>
              <b>Total</b>
            </td>

            <td style={{ textAlign: "right" }}>
              <b>{parseFloat(typetotal).toFixed(2)}</b>
            </td>
          </tr>
        </>
      );
    } else if (type == "Mobile banking") {
      return (
        <>
          {accounts.map((account) => {
            if (type == account.type) {
              let accountTotal = 0;
              data.map((item) => {

                if (item.id == account.id) {
                  typetotal += parseFloat(item.amount);
                  accountTotal += parseFloat(item.amount);
                  // console.log(status);
                }

              });
              return (
                <>
                  <tr>
                    <td style={{ textAlign: "left" }}>{account.name}</td>
                    {/* <td>All</td> */}
                    {/* <td>{account.account_no}</td> */}
                    <td style={{ textAlign: "right" }}>
                      {parseFloat(accountTotal).toFixed(2)}
                    </td>
                  </tr>
                </>
              );
            }
          })}

          <tr>
            <td style={{ textAlign: "left" }} colSpan={1}>
              <b>Total</b>
            </td>

            <td style={{ textAlign: "right" }}>
              <b>{parseFloat(typetotal).toFixed(2)}</b>
            </td>
          </tr>
        </>
      );
    } else {
      let counter = 0;
      let accountTotal = 0;
      data.map((item) => {

        if (item.id == "999") {
          typetotal += parseFloat(item.amount);
          accountTotal += parseFloat(item.amount);
          // console.log(status);
          counter++;
        }

      });
      return (
        <>
          <tr>
            <td style={{ textAlign: "left" }}>Untracked {counter}</td>
            {/* <td>All</td> */}
            {/* <td></td> */}
            <td style={{ textAlign: "right" }}>
              {parseFloat(accountTotal).toFixed(2)}
            </td>
          </tr>

          <tr>
            <td style={{ textAlign: "left" }} colSpan={1}>
              <b>Total</b>
            </td>

            <td style={{ textAlign: "right" }}>
              <b>{parseFloat(typetotal).toFixed(2)}</b>
            </td>
          </tr>
        </>
      );
    }
  };

  return (
    <>
      <Layout className="window-frame">
        <Sidebar />
        <Layout className="site-layout">
          <Navbar />
          <Content className="main-frame-content">
            <Breadcrumb style={{ margin: "16px 0" }}>
              <Breadcrumb.Item>Account status</Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background main-frame">
              {Rendercontent()}
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
    locationlist: state.warehouse.outletlist,
    brandlist: state.brand.brandlist,
  };
};

export default connect(mapStateToProps, {
  getAllAccount,
  getAllLocation,
  getJournalSearchResult,
  getallaccountstatus,
  accountstatus,
  resetAllChartofaccounts,
  getAllOutlet,
})(AccountsStatus);
